module.exports = __webpack_public_path__ + "img/send.31fe7407.svg";